var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchtingExternalAccount)?_c('loading-page'):_c('parent',[_c('external-account-from',{attrs:{"external-account":_vm.externalAccount},on:{"save":_vm.updateAccount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }